import React, { Component } from 'react';
import { Option } from '../../atoms';

import './styles.css';

/**
 * Description
 *
 * @typedef {Object} Props
 * @prop {Array} options
 * @prop {Function} onChange
 *
 * @augments {Component<Props>}
 */
export default class Select extends Component {
	/**
	 * @param {Readonly<Props>} props
	 */
	constructor (props) {
		super(props);

		this.state = {
			opened: false,
			selected: props.options[0],
		};
	}

	componentDidMount () {
		window.addEventListener('keydown', this.closeOnEscape);
		window.addEventListener('click', this.clickOutside);
	}

	componentWillUnmount () {
		window.removeEventListener('keydown', this.closeOnEscape);
		window.removeEventListener('click', this.clickOutside);
	}

	selectRef = React.createRef();

	clickOutside = (/** @type {{ target: any; }} */ e) => {
		if (!this.selectRef.current || !e.target) return;

		if (this.state.opened && !this.selectRef.current.contains(e.target)) {
			this.closeSelect();
		}
	};

	closeOnEscape = (/** @type {{ code: string; }} */ e) => {
		if (e.code === 'Escape' && this.state.opened) {
			this.closeSelect();
		}
	};

	closeSelect () {
		this.setState({ opened: false });
	}

	handleOnOpen = () => {
		this.setState({
			opened: !this.state.opened,
		});
	};

	handleOnSelect = (/** @type {any} */ optionKey) => {
		const option = this.findOption(optionKey);

		if (!option) return;

		this.setState(
			{
				opened: false,
				selected: option,
			},
			() => {
				this.props.onChange(option);
			}
		);
	};

	/**
	 * @param {any} optionKey
	 */
	findOption (optionKey) {
		return this.props.options.find((/** @type {{ key: any; }} */ option) => option.key === optionKey);
	}

	getOptions () {
		return this.props.options.map((/** @type {{ key: any; }} */ o) => (
			<Option
				key={o.key}
				option={o}
				selected={this.state.selected}
				onSelect={this.handleOnSelect}
			/>
		));
	}

	render () {
		const items = this.getOptions();

		return (
			<div className='Select' onClick={this.handleOnOpen} ref={this.selectRef}>
				<span>{this.state.selected.value}</span>
				<ul
					className={`OptionsWrapper ${
						this.state.opened ? 'OptionsWrapperWrapOpen' : ''
					}`}
				>
					{items}
				</ul>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/molecules/Select/Select.js